import React from 'react';
import ContactListBase from './ContactListBase';

// Lists the suppliers, which are always organizations
const SupplierList: React.FC = () => {
    return (
        <ContactListBase
            listKey='contact_supplier'
            objectName='supplier.general.object_name'
            defaultParams={{ contact_type_filter: 'supplier' }}
            formLinkedItem={{ contact_type: 'supplier', entity_type: 'organization' }}
        />
    );
};

export default SupplierList;
